import "./style.css";
import Fundo from '../../assets/Fundo.png';
import { useState } from "react";
import React from 'react';
import api from '../../services/api';
import { useNavigate } from "react-router-dom";
import { useAppContext } from '../../context/AppContext.js';


function Login() {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sucesso, setsucesso] = useState('');
    const [loading, setloading] = useState(false);
    const { setCodAssinante, updateLoginData, setSelectedCompany } = useAppContext();

    function ProcessaLogin(e) {
        e.preventDefault();
        setsucesso('');
        setloading(true);
        api.post('v1/login', {
            email,
        }).then(response => {
            const companiesData = response.data.empresa; // Exemplo: assume que a API retorna empresas em `companies`
            const encryptedKey = response.data.token;  // Exemplo: assume que a API retorna a chave criptografada em `accessKey`

            setCodAssinante(response.data.empresa[0].codassinante);
        
            if (companiesData.length === 1) {
                setSelectedCompany(response.data.empresa[0].codempresa);
            }

            updateLoginData(companiesData, encryptedKey);

            setsucesso('S');
            navigate('/principal');
        }).catch(() => {
            setsucesso('N');
            setloading(false);
        })
    }

    return <div className="container">
        <div className="logina">
            <img className="background-login" src={Fundo} alt="Fundo" />
            <form className="form-login">
                <h3 className="mb-4">Autenticação</h3>

                <div className="form-floating">
                    <input onChange={(e) => setEmail(e.target.value)} type="text" className="form-control" id="edtUsuario" placeholder="Usuário" />
                    <label htmlFor="edtUsuario">Email</label>
                </div>

                <button onClick={ProcessaLogin} className="w-100 btn btn-lg btn-success" disabled={loading}>
                    {loading ? <div>
                        <span className="spinner-border spinner-border-sm text-light" role="status"></span>
                        <span className="ms-2">Autenticando...</span>
                    </div> : <span className="ms-2">Acessar</span>}
                </button>
                {sucesso === 'N' ? <div className="alert alert-danger mt-2" role="alert">Usuário ou senha inválidos</div> : null}
            </form>
        </div>
    </div>
}

export default Login;